import {TextStyle, ViewStyle} from 'react-native';
import Styles from 'src/components/Styles';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {shadowStyles, bodyFontSize, headerFontSize, subHeaderFontSize} =
  getLayoutDescriber();

export function getStyleDescriptor(): {
  [index: string]: ViewStyle & TextStyle;
} {
  return {
    container: {
      flexDirection: 'row',
      marginHorizontal: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m2,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      backgroundColor: '#fff',
      ...shadowStyles().shadow,
    },
    iconView: {
      width: Styles.Spacing.m4,
      borderRadius: Styles.Spacing.m2,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Styles.primaryColor,
      height: Styles.Spacing.m4,
    },
    headerView: {
      justifyContent: 'flex-start',
      height: Styles.Heights.h4,
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: Styles.Spacing.m2,
    },
    snackButton: {
      marginBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
      marginTop: Styles.Spacing.m3 + Styles.Spacing.m1,
      borderWidth: 1,
    },

    titleText: {
      marginLeft: Styles.Spacing.m3,
      color: Styles.darkColor,
      fontSize: headerFontSize(),
      fontWeight: '600',
    },
    snackDescriptionText: {
      color: Styles.darkColor,
      textAlign: 'left',
      fontSize: subHeaderFontSize(),
      fontWeight: '400',
      marginVertical: Styles.Spacing.m1,
    },

    snackButtonText: {
      fontSize: bodyFontSize(),
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '600',
    },
    revolveButtonStyle: {
      fontSize: bodyFontSize(),
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '600',
    },

    label: {
      color: Styles.darkColor,
      fontSize: bodyFontSize(),
    },
    cardNumber: {
      fontSize: bodyFontSize(),
      color: Styles.lightGray,
    },
    revolveAddTxt: {
      color: Styles.black,
      fontWeight: '400',
      fontSize: bodyFontSize(),
    },
    starIconView: {
      alignItems: 'center',
      flexDirection: 'row',
      flex: 1,
    },
    revolveMainTxt: {
      fontWeight: '700',
      fontSize: bodyFontSize(),
      color: Styles.black,
      fontFamily: Styles.FontFamily.comodoVintage,
    },
  };
}

export default {
  getStyleDescriptor,
};
